import classNames from "classnames";
import { type FC, type MutableRefObject } from "react";
import { type DEFAULT_NOTE_DIRECTIONS } from "@/services/api";
import { useNotesTablePersistFilters } from "@/common/NotesTable/service/use-notes-table-persist-filters";
import type { Widget, WidgetContent } from "../../../types";
import { GridItemContainer } from "../../GridItemContainer";
import { WIDGET_CONTENTS_IDS } from "../../../constants";
import { CommitmentsControlButtons } from "../../CommitmentsControlButtons";
import styles from "../styles.module.scss";

type Props = {
  widget: Widget;
  currentWidget: WidgetContent;
  itemRefs: MutableRefObject<HTMLDivElement[]>;
  handleDelete: (id: string) => void;
  index: number;
};

export const GridItemDesktop: FC<Props> = ({
  widget,
  currentWidget,
  itemRefs,
  handleDelete,
  index,
}) => {
  const {
    clearAllFilters,
    directionFilter: { directionFilter, setDirectionFilter },
  } = useNotesTablePersistFilters({ widgetId: widget.id });
  return (
    <GridItemContainer
      headerAddableNode={
        widget.widgetContentId === WIDGET_CONTENTS_IDS.COMMITMENTS_TABLE && (
          <CommitmentsControlButtons
            defaultValue={directionFilter}
            onChange={(value) => setDirectionFilter(value as keyof typeof DEFAULT_NOTE_DIRECTIONS)}
          />
        )
      }
      ref={(el) => {
        if (!el) return;
        itemRefs.current[index] = el;
      }}
      onRemoveClick={() => {
        handleDelete(widget.id);
        clearAllFilters();
      }}
      title={currentWidget.title}
    >
      <div
        className={classNames(styles["grid-item-content"], {
          [styles["grid-item-content-calendar"]]: widget.widgetContentId === 3,
        })}
      >
        {currentWidget.content({ directionFilter: directionFilter }, widget)}
      </div>
    </GridItemContainer>
  );
};
